import styled from "styled-components";

export const ActionRequestsContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  font-size: 1rem;
`;
